import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ClientsService } from '../../../clients/clients.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit, OnDestroy {

  currentItem: any;
  private deleteSubscription: Subscription;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, private toastService: ToastrService, private clientsService:ClientsService) { 
    this.currentItem = config.data;
  }

  ngOnInit(): void {
  }

  deleteUserFormSub(){
    this.deleteSubscription = this.clientsService.deleteUser(this.currentItem.companyId,this.currentItem.employeeId).subscribe((response:any) => {
      if(response && response.status === 200){
        this.toastService.success(response.message, 'Success');
        this.ref.close(true);
      }
    });
  }

  closeDialog(){
    this.ref.close();
  }

  ngOnDestroy(): void{
    this.deleteSubscription.unsubscribe();
  }

}
